import React from "react";
import useApp from "../../store/app/appContext";
import PageWrapper from '../../containers/app/PageWrapper';
import AppointmentsDetails from "../../containers/appointments/appointmentDetails";
import CalendlyProvider from "../../store/appointments/appointmentsProvider";

function AppointmentsPage() {
  const { appState: { user }} = useApp();

  if (!user) return '';
  if (!user._id) return '';

  return (
    <CalendlyProvider>
      <PageWrapper navbar >
        <AppointmentsDetails />
      </PageWrapper>
    </CalendlyProvider>
  );
}

export default AppointmentsPage;
